import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    textAlign: 'center',
  },

  image: {
    height: theme.spacing(25),

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },

  title: {
    padding: theme.spacing(1.875, 0, 1),

    '&.MuiTypography-root': {
      textTransform: 'uppercase',
      fontFamily: '"Bebas Neue"',
      letterSpacing: '0.05em',
      lineHeight: 1,
      fontSize: theme.spacing(6),
    },
  },

  button: {
    '&.MuiButton-root': {
      color: theme.palette.text.primary,
      fontSize: theme.spacing(2),
      textTransform: 'capitalize',
    },
  },

  unlink: {
    '&.MuiButton-root': {
      backgroundColor: theme.palette.modal.default,
      borderColor: theme.palette.error.light,

      '&:hover': {
        backgroundColor: theme.palette.error.light,
      },
    },
  },
}));
